import { Injectable } from '@angular/core';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { BaseResponse, NotificationServer, NotificationTestParams } from '@m4u-angular/base/entities/BaseEntities';
import { Observable } from 'rxjs';
import { APIGatewayService } from '../gateway/APIGateway.service';

@Injectable()
export class NotificationServerEndpoint extends BaseEndpointCRUD<NotificationServer> {
    constructor(api: APIGatewayService) {super("NotificationServer", api);}
    
    public TestNotificationServer(Params: NotificationTestParams): Observable<BaseResponse> {
        return this.api.ExecutePostAction(this.ControllerName, 'TestNotificationServer', Params);
    }
}